import * as React from 'react';

import cn from 'classnames';
import { debounce } from 'throttle-debounce';

import { Translate } from '@decorators';

import { AppDialog, Loader } from '@components';

import { STICKY_BUTTON_TOP, LOADING_OFFSET, LOADING_THROTTLING_MS } from './constants';

import { IInviteFriendsDialogProps, IInviteFriendsDialogState } from './types';

import * as s from './InviteFriendsDialog.scss';

@Translate('components.AppMainPage.InviteFriendsDialog')
export class InviteFriendsDialog extends React.PureComponent<
	IInviteFriendsDialogProps, IInviteFriendsDialogState
> {

	state: IInviteFriendsDialogState = {
		selected: [],
		stickyButton: false,
	};

	checkShowMore = debounce(LOADING_THROTTLING_MS, (container: HTMLElement) => {
		const { scrollTop, offsetHeight, scrollHeight } = container;
		const isNeedToLoadMore = (scrollTop + offsetHeight + LOADING_OFFSET) > scrollHeight;
		if (isNeedToLoadMore) {
			this.props.onMore();
		}
	});

	scrollHandler = (event: React.UIEvent<HTMLElement>) => {
		const container = event.currentTarget;
		this.setState({
			stickyButton: container.scrollTop > STICKY_BUTTON_TOP,
		});
		this.checkShowMore(container);
	};

	inviteHandler = () => this.props.onInvite(this.state.selected);

	toggleUID = (uid: string) => () => this.setState(({ selected }) => ({
		selected: selected.includes(uid)
			? selected.filter((selectedUID) => selectedUID !== uid)
			: [...selected, uid],
	}));

	render() {
		const {
			appTitle,
			friends = [],
			onClose,
			loading,
		} = this.props;
		const {
			stickyButton,
			selected,
		} = this.state;

		return <AppDialog
			title={this.t('inviteFriends')}
			visible={true}
			onClose={onClose}
			onScroll={this.scrollHandler}
		>
			<div className={cn(s.dialog, { [s.sticky]: stickyButton })}>
				<div className={s.header}>
					{this.t('inviteFriendsToJoin')}&nbsp;<b>{appTitle}</b>
				</div>

				<div className={s.buttonWrapper}>
					<button
						className={s.inviteButton}
						onClick={this.inviteHandler}
						disabled={selected.length === 0}
					>
						{this.t('inviteFriends')}
					</button>
				</div>

				{friends.length
					? <div className={s.list}>
						{friends.map(({ avatar, name, uid }) =>
							<label className={s.friend} key={uid}>
								<img className={s.avatar} src={avatar} />
								<span className={s.name}>{name}</span>
								<input
									className={s.input}
									type="checkbox"
									onClick={this.toggleUID(uid)}
								/>
								<div className={s.checkbox} />
							</label>)}
					</div>
					: null}

				{loading && <div className={s.loaderWrapper}>
					<Loader />
				</div>}
			</div>
		</AppDialog>;
	}

}
